import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { Button, Flex, Image, Label, Segment, Text } from "@fluentui/react-northstar";
import { InfoIcon } from '@fluentui/react-icons-northstar';
import { initializeIcons, Icon } from '@fluentui/react';
import {
    getAppConfig,
    getMeetingData,
    getMeetingQueueData,
    getAppSettings,
    rating,
    updateAssuntoQueue,
    startCall,
    inactivateQueue,
    getAuthUrl,
    getUserProfile,
    getOrCreateMeetingQueueAuth,
    getMeetingQueueByRequestId,
} from '../../api/publicapp-api';
import { isAcsEnabled } from '../../api/acs-api';
import QueueWelcomeCard from "./queue-auth-cards/bem-vindo";
import QueueNaFilaCard from "../meeting-queue/queue-cards/na-fila";
import QueueStartedCard from "../meeting-queue/queue-cards/atendimento-iniciado";
import QueueEndedCard from "../meeting-queue/queue-cards/atendimento-encerrado";
import QueueInactivedCard from "../meeting-queue/queue-cards/atendimento-inativo";
import QueueScheduledCard from "../meeting-queue/queue-cards/atendimento-agendado";
import QueueCancelledCard from "../meeting-queue/queue-cards/atendimento-cancelado";
import RedirectUrlsConstants from '../../constants/redirect-urls';
import StatusQueueConstants from "../../constants/status-queue";
import ConstantsSoundBeep from '../../constants/sound-beep';
import VLibras from "@djpfs/react-vlibras";
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import "../meeting-queue/meeting-queue.scss";

interface IState {
    appConfigs: any;
    appSettings: any;
    botWriting: boolean;
    botWriting1: boolean;
    step: number;
    meetingData: any;
    meetingQueueData: any;
    queues: any;
    keepAliveInterval: any;
    lastSeenInterval: any;
    inativo: boolean;
    rate: number;
    rateLabel: string;
    comments: string;
    ratingSent: boolean;
    callInProgress: boolean;
    assuntoSelected?: any;
    ratingQuestions?: any;
    scheduled: boolean;
    loggedIn: boolean;
    token: string;
    userProfileData: any | null;
    acsEnabled: boolean;
    loadingGovBr: boolean;
}

export type MeetingQueueAuthProps = {} & RouteComponentProps & WithTranslation;

class MeetingQueueAuth extends React.Component<MeetingQueueAuthProps, IState> {
    requestId?: any = null;
    assuntoParam?: any = null;
    ancora?: any = null;
    audio?: any = null;
    audioElement?: any = null;
    private localize: TFunction;

    constructor(props: MeetingQueueAuthProps) {
        super(props);
        initializeIcons();
        this.localize = this.props.t;

        this.audioElement = React.createRef();

        this.state = {
            appConfigs: null,
            appSettings: null,
            botWriting: true,
            botWriting1: false,
            step: 0,
            meetingData: [],
            meetingQueueData: {},
            queues: [],
            keepAliveInterval: null,
            lastSeenInterval: null,
            inativo: false,
            rate: 0,
            rateLabel: "",
            comments: "",
            ratingSent: false,
            callInProgress: false,
            assuntoSelected: null,
            ratingQuestions: null,
            scheduled: false,
            loggedIn: false,
            token: window.localStorage.getItem("token") ?? "",
            userProfileData: null,
            acsEnabled: false,
            loadingGovBr: false,
        }

        this.initParams();
    }


    /**
    * Used to initialize this component.
    */
    public componentDidMount = async () => {
        setTimeout(() => this.setState({ botWriting: false }), 2500);

        this.getAppConfig();
        this.getAppSettings();
        //this.isAcsEnabled();
        this.getMeetingData();
        this.getMeetingQueueDataByRequestId().then((res: any) => {
            if (window.localStorage.getItem("token")) {
                this.setState({
                    loggedIn: true,
                })

                this.getUserProfile(this.state.token);
            }
        });
    }

    /**
     * Save the request id in local storage
     * */
    private initParams = () => {
        let search = new URLSearchParams(window.location.search);

        let dataParameter = search.get("data");

        if (dataParameter) {
            let data = dataParameter ? window.atob(dataParameter) : "";
            let dataValue = JSON.parse(data);

            this.requestId = dataValue['requestId'] ?? "";
            this.assuntoParam = decodeURIComponent(dataValue['assunto']) ?? null;
            this.ancora = dataValue['ancora'] ?? "";

            this.saveParametersLocalStorage(dataParameter);

            if (this.requestId == "") {
                window.location.pathname = `/errorpage?msg=QueueId is invalid`;
            }
        }
    };

    /**
     * Save the request id in local storage
     * */
    private saveParametersLocalStorage = async (data: string) => {
        window.localStorage.setItem("data", data);
    };

    /**
     * Auth user with Gov.BR provider
     * */
    private getAuthUrl = async () => {
        let response = await getAuthUrl();

        if (response.status === 200 && response.data) {
            window.location.assign(response.data);
        }
    };

    /**
     * Logout Gov.BR provider
     * */
    private logout = async () => {
        let _self = this;
        let win = window.open('https://sso.staging.acesso.gov.br/logout', 'null', 'height=1,width=1,status=no, toolbar=no,menubar=no,location=no');

        return [2, new Promise(function (resolve: any, reject: any) {
            setTimeout(function () {
                (win as any).close();

                _self.setState({
                    loggedIn: false,
                })

                window.location.assign(`${window.location.origin}/meeting/${_self.ancora}`);

                resolve({});
            }, 2000);
        })];
    };

    /**
     * Get the user profile
     * */
    private getUserProfile = async (token: string) => {
        this.setState({
            loadingGovBr: true,
        })

        let response = await getUserProfile(token);

        if (response.status === 200 && response.data) {
            this.setState({
                userProfileData: response.data,
                loadingGovBr: false,
            })

            this.getOrCreateMeetingQueue(response.data);
        }
    };

    /**
    * Get meeting queue by request id
    */
    public getMeetingQueueDataByRequestId = async () => {
        let response = await getMeetingQueueByRequestId(this.requestId);

        if (response.status === 200 && response.data) {
            this.setState({
                meetingQueueData: response.data,
                loggedIn: window.localStorage.getItem("token") ? true : false,
                userProfileData: response.data.userProfile,
            }, () => {
                //if (this.state.assuntoSelected) {
                //    updateAssuntoQueue(response.data.id, this.state.assuntoSelected)
                //}

                if (response.data.status == StatusQueueConstants.atendimentoAgendado) {
                    this.setState({
                        scheduled: true,
                    })
                }

                if (response.data.status == StatusQueueConstants.naFila || response.data.scheduleDay) {
                    this.refreshQueue(response.data.userProfile);
                }
            })
        }
    }

    /**
    * Create meeting queue
    */
    public getOrCreateMeetingQueue = async (userProfile: any) => {
        let response = await getOrCreateMeetingQueueAuth(this.ancora, this.requestId, userProfile);

        if (response.status === 200 && response.data) {
            this.setState({
                meetingQueueData: response.data,
            })

            window.localStorage.clear();

            //if (this.state.assuntoSelected) {
            //    updateAssuntoQueue(response.data.id, this.state.assuntoSelected)
            //}

            if (response.data.status == StatusQueueConstants.atendimentoAgendado ||
                response.data.history.find((e: any) => e.status == StatusQueueConstants.atendimentoAgendado)) {
                this.setState({
                    scheduled: true,
                })
            }

            if (response.data.status == StatusQueueConstants.naFila || response.data.scheduleDay) {
                this.refreshQueue(userProfile);
            }
        }
    }

    /**
     * Get App Configs
     * */
    private getAppConfig = async () => {
        let response = await getAppConfig();
        if (response.status === 200 && response.data) {

            if (response.data?.queueRingSound?.toLowerCase() == "queuesoundtelephone") {
                this.audio = ConstantsSoundBeep.queueSoundTelephone;
            }
            else {
                this.audio = ConstantsSoundBeep.queueSoundDefault;
            }

            this.setState({
                appConfigs: response.data,
                ratingQuestions: response.data?.ratingQuestions ? JSON.parse(response.data.ratingQuestions) : null
            });
        }
    };

    /**
     * Get App Settings
     * */
    private getAppSettings = async () => {
        let response = await getAppSettings();
        if (response.status === 200 && response.data) {
            this.setState({
                appSettings: response.data,
            });
        }
    };

    /**
     * Check if ACS is enabled
     * */
    //private isAcsEnabled = async () => {
    //    let response = await isAcsEnabled();
    //    if (response.status === 200 && response.data) {
    //        this.setState({
    //            acsEnabled: response.data,
    //        });
    //    }
    //};

    /**
    * Get meeting data.
    */
    public getMeetingData = async () => {
        let response = await getMeetingData(this.ancora);

        if (response.status === 200 && response.data) {
            this.setState({
                meetingData: response.data,
            });

            var matchAssunto = response.data.assuntos?.filter((v: string) => this.assuntoParam.toLowerCase() === v.toLowerCase());

            if (matchAssunto?.length) {
                this.setState({
                    assuntoSelected: matchAssunto,
                })
            }
        }
    }

    public refreshQueue = async (userProfile: any) => {
        let keepAlive = setInterval(() => {
            getMeetingQueueData(this.ancora, this.state.meetingQueueData.id).then((result: any) => {
                this.setState({
                    meetingQueueData: {
                        ...this.state.meetingQueueData,
                        queues: result.data.queues,
                        queuePosition: result.data.queuePosition,
                        status: result.data.status,
                        meetingUrl: result.data.meetingUrl,
                        assuntoSelected: result.data.assuntos,
                    }
                });

                if (result.data.status == StatusQueueConstants.atendimentoIniciado) {
                    this.alertBeep(true);
                    clearInterval(this.state.lastSeenInterval);
                }

                if (result.data.status == StatusQueueConstants.emAtendimento) {
                    this.alertBeep(false);
                    this.setState({ callInProgress: true })
                    clearInterval(this.state.lastSeenInterval);
                }

                if (result.data.status == StatusQueueConstants.atendimentoEncerrado ||
                    result.data.status == StatusQueueConstants.atendimentoInativo ||
                    this.state.inativo) {
                    clearInterval(this.state.keepAliveInterval);
                    clearInterval(this.state.lastSeenInterval);
                }
            })
        }, 20000);

        this.setState({
            keepAliveInterval: keepAlive,
        })
    }

    /**
    * Update user last seen.
    */
    public startCall = () => {
        this.alertBeep(false);

        let meetingUrl = this.state.meetingQueueData.meetingUrl;
        let isAcsEnabled = this.state.acsEnabled;

        if (!this.state.callInProgress) {
            if (isAcsEnabled) {
                startCall(this.state.meetingQueueData.id, this.ancora).then(() => {
                    this.setState({ callInProgress: true })
                });
            } else {
                startCall(this.state.meetingQueueData.id, this.ancora).then(() => {
                    this.setState({ callInProgress: true })

                    if (this.state.appConfigs.useTeamsAppForJoin) {
                        meetingUrl = meetingUrl.replace(RedirectUrlsConstants.browserForJoin, RedirectUrlsConstants.teamsAppForJoin);
                        window.open(meetingUrl);
                    }
                    else {
                        window.open(meetingUrl);
                    }
                });
            }
        } else {
            if (this.state.appConfigs.useTeamsAppForJoin) {
                meetingUrl = meetingUrl.replace(RedirectUrlsConstants.browserForJoin, RedirectUrlsConstants.teamsAppForJoin);
                window.open(meetingUrl);
            }
            else {
                window.open(meetingUrl);
            }
        }
    }

    /**
    * Queue wait time.
    */
    public timerTimeout = async () => {
        if (!this.state.callInProgress) {
            inactivateQueue(this.state.meetingQueueData.id, this.ancora).then((response: any) => {
                this.setState({ inativo: true })
                this.alertBeep(false)
                clearInterval(this.state.keepAliveInterval);
                clearInterval(this.state.lastSeenInterval);
            })
        }
    }

    /**
    * Alert beep.
    */
    public alertBeep = (play: boolean) => {
        if (play) {
            this.audioElement.current.currentTime = 0;
            this.audioElement.current.muted = false;
        } else {
            this.audioElement.current.muted = true;
            this.audioElement.current.pause();
        }
    }

    /**
    * Rating.
    */
    public setRating = (rate: number) => {
        this.setState({
            rate: rate
        })

        if (rate == 1) {
            this.setState({ rateLabel: this.localize("Ruim") })
        } else if (rate == 2) {
            this.setState({ rateLabel: this.localize("Regular") })
        } else if (rate == 3) {
            this.setState({ rateLabel: this.localize("Bom") })
        } else if (rate == 4) {
            this.setState({ rateLabel: this.localize("Ótimo") })
        } else if (rate == 5) {
            this.setState({ rateLabel: this.localize("Excelente") })
        }
    }

    /**
    * Send rate.
    */
    public sendRating = () => {
        var objRating = {
            Rate: this.state.rate,
            Comments: this.state.comments
        };

        rating(this.state.meetingQueueData.id, this.ancora, objRating).then((response: any) => {
            this.setState({ ratingSent: true })
        })
    }

    /**
    * Send custom rating.
    */
    public sendCustomRating = () => {
        rating(this.state.meetingQueueData.id, this.ancora, JSON.stringify(this.state.ratingQuestions)).then((response: any) => {
            this.setState({ ratingSent: true })
        })
    }

    /**
     * Parse week days with locale
     * */
    public daysOfWeekLocale = (day: string) => {
        if (day)
            return day
                .replace(/segunda-feira/, this.localize('SegundaFeira'))
                .replace(/terça-feira/, this.localize('TercaFeira'))
                .replace(/quarta-feira/, this.localize('QuartaFeira'))
                .replace(/quinta-feira/, this.localize('QuintaFeira'))
                .replace(/sexta-feira/, this.localize('SextaFeira'))
                .replace(/sabado/, this.localize('Sabado'))
                .replace(/domingo/, this.localize('Domingo'))
    }

    /**
    * Render header.
    */
    public renderHeader = () => {
        return (
            this.state.appConfigs ?
                <Flex>
                    <audio muted autoPlay loop id="alertBeep" ref={this.audioElement} hidden={true} controls>
                        <source src={this.audio} type="audio/wav" />
                    </audio>
                    <Flex.Item>
                        <Flex gap="gap.small" vAlign="center">
                            <Image src="https://studio365cdn.azureedge.net/balcaovirtual/logo.png" />
                            <Text weight="semibold" content={this.localize("BalcaoVirtual").toUpperCase()} size="medium" />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item grow>
                        <Flex hAlign="center" vAlign="center">
                            <Label className="headerLabel" content={this.state.appConfigs.tribunal} />
                        </Flex>
                    </Flex.Item>
                    <Flex.Item>
                        <Flex gap="gap.smaller" vAlign="center" className="sobre">
                            <InfoIcon outline />
                            <Text weight="light" content={this.localize("Sobre")} size="small" />
                        </Flex>
                    </Flex.Item>
                </Flex>
                :
                <React.Fragment />
        )
    }

    /**
    * Render Assuntos.
    */
    public renderAssuntos = (item: any, index: number) => {
        return (
            <Button key={index} content={item} primary onClick={() => {
                //updateAssuntoQueue(this.state.meetingQueueData.id, item).then((response: any) => {
                //    this.setState({
                //        assuntoSelected: item
                //    })
                //})
            }} />
        )
    }

    /**
    * Rating question changed.
    */
    private onQuestionChanged = (event: any) => {
        var indexSession = event.currentTarget.className.split('-')[0];
        var questionId = event.currentTarget.className.split('-')[1];
        var indexQuestion = this.state.ratingQuestions.data.sessions[indexSession].questions.findIndex((obj: any) => obj.id === questionId);

        this.state.ratingQuestions.data.sessions[indexSession].questions[indexQuestion].selectedValue = event.currentTarget.id;
        this.state.ratingQuestions.data.sessions[indexSession].questions[indexQuestion].selectedText = event.currentTarget.value;

        this.setState({
            ratingQuestions: this.state.ratingQuestions
        })
    }

    private onCommentChange = (event: any) => {
        this.setState({
            comments: event.target.value,
        });
    }

    /**
    * Render body.
    */
    public renderWelcomeCard = () => {
        return (
            <React.Fragment>
                {(this.state.meetingQueueData.status != StatusQueueConstants.atendimentoEncerrado &&
                    !this.state.inativo)
                    &&
                    <QueueWelcomeCard
                        botWriting={this.state.botWriting}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        daysOfWeekLocale={this.daysOfWeekLocale}
                        getAuthUrl={this.getAuthUrl}
                        logout={this.logout}
                        loggedIn={this.state.loggedIn}
                        userProfile={this.state.userProfileData}
                        loadingGovBr={this.state.loadingGovBr}
                    />
                }

                {!this.state.botWriting &&
                    this.renderCards()
                }

            </React.Fragment>
        )
    }

    /**
     * Render queue cards.
     * */
    public renderCards = () => {
        return (
            <React.Fragment>
                {/*{(this.state.meetingQueueData.queuePosition > 0 &&*/}
                {/*    !this.state.inativo &&*/}
                {/*    this.state.meetingQueueData.status != StatusQueueConstants.atendimentoAgendado) &&*/}
                {/*    <QueueNaFilaCard*/}
                {/*        botWriting1={this.state.botWriting1}*/}
                {/*        appConfigs={this.state.appConfigs}*/}
                {/*        meetingData={this.state.meetingData}*/}
                {/*        meetingQueueData={this.state.meetingQueueData}*/}
                {/*        assuntoSelected={this.state.assuntoSelected}*/}
                {/*        renderAssuntos={this.renderAssuntos.bind(this)}*/}
                {/*    />*/}
                {/*}*/}

                {/*{((this.state.meetingQueueData.status == StatusQueueConstants.atendimentoIniciado ||*/}
                {/*    this.state.meetingQueueData.status == StatusQueueConstants.emAtendimento)*/}
                {/*    && !this.state.inativo && this.state.loggedIn) &&*/}
                {/*    <QueueStartedCard*/}
                {/*        botWriting1={this.state.botWriting1}*/}
                {/*        appConfigs={this.state.appConfigs}*/}
                {/*        appSettings={this.state.appSettings}*/}
                {/*        meetingData={this.state.meetingData}*/}
                {/*        meetingQueueData={this.state.meetingQueueData}*/}
                {/*        startCall={this.startCall}*/}
                {/*        callInProgress={this.state.callInProgress}*/}
                {/*        timerTimeout={this.timerTimeout}*/}
                {/*        scheduled={this.state.scheduled}*/}
                {/*        acsEnabled={this.state.acsEnabled}*/}
                {/*    />*/}
                {/*}*/}

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoEncerrado) &&
                    <QueueEndedCard
                        botWriting1={this.state.botWriting1}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        ratingSent={this.state.ratingSent}
                        rate={this.state.rate}
                        rateLabel={this.state.rateLabel}
                        setRating={this.setRating}
                        sendRating={this.sendRating}
                        ratingQuestions={this.state.ratingQuestions}
                        onCommentChange={this.onCommentChange}
                        onQuestionChanged={this.onQuestionChanged}
                        sendCustomRating={this.sendCustomRating}
                    />
                }

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoAgendado && this.state.loggedIn) &&
                    <QueueScheduledCard
                        botWriting={this.state.botWriting}
                        ancora={this.ancora}
                        meetingData={this.state.meetingData}
                        meetingQueueData={this.state.meetingQueueData}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        daysOfWeekLocale={this.daysOfWeekLocale}
                    />
                }

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoInativo ||
                    this.state.inativo) &&
                    <QueueInactivedCard
                        botWriting1={this.state.botWriting1}
                        ancora={this.ancora}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingQueueData={this.state.meetingQueueData}
                    />
                }

                {(this.state.meetingQueueData.status == StatusQueueConstants.atendimentoCancelado) &&
                    <QueueCancelledCard
                        botWriting1={this.state.botWriting1}
                        ancora={this.ancora}
                        appConfigs={this.state.appConfigs}
                        appSettings={this.state.appSettings}
                        meetingQueueData={this.state.meetingQueueData}
                    />
                }
            </React.Fragment>
        )
    }

    /**
     * Render this component.
     * */
    public render(): JSX.Element {
        return (
            <div className="meeting-queue">
                <div>
                    <VLibras forceOnload={true} />
                </div>
                <div className="header">
                    <Segment
                        className="headerLine"
                        inverted
                        content={this.renderHeader()}
                    />
                </div>
                <div className="body">
                    {this.renderWelcomeCard()}
                </div>
            </div>
        );
    }
}

const meetingQueueAuthWithTranslation = withTranslation()(MeetingQueueAuth);
export default meetingQueueAuthWithTranslation;